// Client-side mirror of Bot/templateEngine.js's renderTemplate() on the
// server, used only for the dashboard's live preview pane. Keep the
// substitution/collapse rules identical to the backend so the preview
// matches what will actually be sent.
const PLACEHOLDER_PATTERN = /\{(title|header|text_preview|link|category|date)\}/g;

export const SAMPLE_ARTICLE = {
  title: "Sample headline for the preview",
  header: "A short deck line under the headline",
  text_preview: "This is a preview of the article body, trimmed to the first 200 characters so the message stays short...",
  link: "https://alameennews.net/ar/news/sample-headline",
  category: "Politics",
  date: new Date().toLocaleDateString(),
};

export function renderTemplatePreview(content, values = SAMPLE_ARTICLE) {
  const substituted = (content || "").replace(PLACEHOLDER_PATTERN, (_, key) => values[key] ?? "");

  const lines = substituted.split("\n").map((line) => line.trim());
  const collapsed = lines.filter((line, i) => line !== "" || lines[i - 1] !== "");

  return collapsed.join("\n").trim();
}
